import * as React from "react";
import { useForm } from "react-hook-form";
import "../data-source/CreateDataSource.css";
import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import Card, { CardBody, CardFooter } from "../../../components/bootstrap/Card";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Checks from "../../../components/bootstrap/forms/Checks";
import CustomScrollbar from "../../../components/bootstrap/CustomScrollbar";
import Button from "../../../components/bootstrap/Button";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";
import ToastComponent from "../../../components/ToastComponent";

export default function EditRole(props: any) {
  const id = props.roleId;
  //const id = (props.roleId !== null && props.roleId !== undefined) ? props.roleId : 1;
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const form = useForm<FormValues>();
  const { handleSubmit } = form;
  const [users, setUsers] = React.useState<any[]>([]);
  const [usersDuplicate, setUsersDuplicate] = React.useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [successMessage, setSuccessMessage] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [searchInput, setSearchInput] = React.useState<string>("");
  const [formData, setFormData] = React.useState<FormValues>({
    roleName: "",
    roleId: 0,
    users: [],
  });

  type FormValues = {
    roleName: string;
    roleId: number;
    users: any[];
  };

  const addOrRemoveUsersToGroupOnCheckboxChange = (event: any) => {
    const { checked, value } = event.currentTarget;
    setSelectedUsers((prev: any) =>
      checked
        ? [...prev, value]
        : prev.filter((val: any) => Number(val) !== Number(value))
    );
  };
  const fetchRole = async (id: number) => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${vyu_api_url}/role/getById?id=${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setFormData(data);
      setSelectedUsers(data.userIdList);

      if (response.ok) {
        setDisabled(false);
      }
    } catch (e) {
      console.error("Error creating Role:", e);
      setErrorMessage("An error occurred while creating Role");
    }
  };
  const getAllUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${vyu_api_url}/user/allUser`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setUsers(data);
        setUsersDuplicate(data);
      }
    } catch (e) {}
  };
  React.useEffect(() => {
    getAllUsers();
    fetchRole(id);
  }, []);

  const saveRole = async (id: number) => {
    const token = localStorage.getItem("token");
    const formDataObject = {
      roleName: capitalizeAllLetter(formData.roleName),
      roleId: id,
      userIdList: selectedUsers,
    };

    try {
      const response = await fetch(`${vyu_api_url}/role/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formDataObject),
      });
      if (response.ok) {
        setSuccessMessage("Role Updated successfully!");
        handleSuccess("Role Updated successfully!");
      } else {
        const data = await response.json();
        setErrorMessage(data.message || "Failed to update Role!");
        handleError(data.message || "Failed to create role!");
      }
    } catch (e) {
      console.error("Error creating Role:", e);
      setErrorMessage("An error occurred while creating Role");
    }
  };
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    if (formData.roleName !== "") {
      setDisabled(false);
    }
  };
  const handleReset = () => {
    setFormData({
      roleName: "",
      roleId: 0,
      users: [],
    });
    setDisabled(true);
    setShow(false);
    setSelectedUsers([]);
  };

  const onSubmit = () => {
    saveRole(id);
  };

  const handleCheckBox = async () => {
    try {
      setDisabled(false);
      setShow((prev) => !prev);
    } catch (e) {
      console.error(e);
    }
  };

  function handleSearchInput1Change(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    const val = event.target.value;
    setSearchInput(val);
    let allUsers = usersDuplicate;
    let filteredUsers = allUsers.filter(
      (item) =>
        item.firstName.toLowerCase().startsWith(val.toLowerCase()) ||
        item.lastName.toLowerCase().startsWith(val.toLowerCase())
    );
    setUsers(filteredUsers);
  }
  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };
  return (
    // <>
    //     <h1 className="font-bold  text-3xl pb-2 italic ml-3"><span className="text-3xl font-light"></span>Edit Roles</h1>
    //     <div className="flex flex-row  h-screen bg-slate-200">
    //         <div className="p-4 mt-100 basis-1/2 h-screen  bg-white">
    //             <form onSubmit={handleSubmit(onSubmit)}>
    //                 <label className="text-xl italic" htmlFor="roleName">
    //                     Role Name
    //                 </label>
    //                 <input
    //                     className="shadow-md italic w-full h-10 mb-6"
    //                     // fullWidth
    //                     // variant="outlined"
    //                     id="roleName"
    //                     name="roleName"
    //                     placeholder="Enter name of the role"
    //                     value={formData.roleName}
    //                     onChange={handleChange}
    //                 />
    //                 <br />
    //                 <br />

    //                 <div className="w-full  flex items-center justify-center">
    //                     <button className="basis-1/2 m-1 text-black italic bg-violet-200  hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100" type="button" onClick={handleReset}>Reset</button>
    //                     <button className="basis-1/2 m-1 text-white italic bg-blue-500 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2 dark:bg-blue-500 dark:hover:bg-blue-800">Submit</button>
    //                 </div>
    //             </form>
    //         </div>
    //         <div className="mt-100 basis-1/2 p-4 h-screen bg-slate-200 items-center justify-center">
    //             <div className="items-center self-center justify-items-center">
    //                 <FormControlLabel
    //                     label={<h1 className="text-xl italic">Add/Remove users from role?</h1>}
    //                     control={
    //                         <Checkbox
    //                             //   disabled={disabled}
    //                             className="rounded-lg bg-black"
    //                             onChange={handleCheckBox}
    //                             inputProps={{ "aria-label": "Preview" }}
    //                             aria-label="pr"
    //                         />
    //                     }
    //                 />
    //                 {
    //                     show && (
    //                         <Paper style={{ width: '100%', height: '100%' }} elevation={3}>
    //                             <div
    //                             //   className="create-ds-test-connection"
    //                             >
    //                                 <div className="section-1">
    //                                     <div className='vertical-line-2'></div>
    //                                     <div>
    //                                         <input
    //                                             type="text"
    //                                             placeholder="Search..."
    //                                             value={searchInput}
    //                                             onChange={handleSearchInput1Change}
    //                                         />
    //                                     </div>
    //                                 </div>
    //                                 <div className='checkbox-area-1'>
    //                                     {users.map((item) => (
    //                                         <div>
    //                                             <input
    //                                                 key={item.userId}
    //                                                 value={item.userId}
    //                                                 type="checkbox"
    //                                                 className='custom-checkbox'
    //                                                 defaultChecked={selectedUsers.some(val => val === item.userId)}
    //                                                 // onChange={addUserToGroup}
    //                                                 // checked={selectedUsers.some(val => val === item.id)}
    //                                                 onChange={addOrRemoveUsersToGroupOnCheckboxChange}
    //                                             />
    //                                             <label>{"  " + item.firstName + " " + item.lastName}</label>
    //                                         </div>
    //                                     ))}
    //                                 </div>
    //                             </div>
    //                         </Paper>
    //                     )}
    //             </div>
    //         </div>
    //     </div>

    // </>
    <>
      {/* <Breadcrumb
        list={[
          { title: "Roles", to: "" },
          { title: "List Roles", to: "" },
          { title: "Edit Roles", to: "" },
        ]}
      /> */}
      <div className="row">
        <div className="col-lg-12">
          <Card stretch style={{ borderRadius: "4px" }}>
            <CardBody>
              {/* <h1 className="font-bold  text-3xl pb-2 italic ml-3">
                <span className="text-3xl font-light"></span>Edit Roles
              </h1> */}
              <div className="col-lg-6">
                <FormGroup label="Role Name">
                  <Input
                    // className="shadow-md italic w-full h-10 mb-6"
                    // fullWidth
                    // variant="outlined"
                    style={smallRadius}
                    className={inputStyle}
                    id="roleName"
                    name="roleName"
                    placeholder="Enter name of the Role"
                    value={formData.roleName}
                    onChange={handleChange}
                  />
                </FormGroup>
              </div>
              <br />
              <div className="col-lg-6 mb-4">
                <FormGroup label="Add users to role?">
                  <Checks
                    //disabled={disabled}
                    className="rounded-lg bg-black"
                    onChange={handleCheckBox}
                    checked={show}
                    type="checkbox"
                    aria-label="pr"
                  />
                </FormGroup>
                {show && (
                  <Card stretch style={{ borderRadius: "4px" }}>
                    <CardBody>
                      <>
                        <div className="mb-1 mt-3">
                          <input
                            type="text"
                            // className="form-control"
                            style={smallRadius}
                            className={inputStyle}
                            onChange={handleSearchInput1Change}
                            placeholder="Search..."
                            name="search"
                          />
                        </div>
                        <CustomScrollbar height="200px">
                          {users.map((item) => (
                            <div className="m-2" key={item.userId}>
                              <input
                                value={item.userId}
                                type="checkbox"
                                className="custom-checkbox p-1"
                                defaultChecked={selectedUsers.some(
                                  (val) => val === item.userId
                                )}
                                onChange={
                                  addOrRemoveUsersToGroupOnCheckboxChange
                                }
                              />
                              <label className="m-2">
                                {item.firstName + " " + item.lastName}
                              </label>
                            </div>
                          ))}
                        </CustomScrollbar>
                      </>
                    </CardBody>
                  </Card>
                )}
              </div>
            </CardBody>

            <CardFooter>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  // className="w-full flex items-center justify-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                    // border: "1px solid black",
                  }}
                >
                  <Button
                    isLight={true}
                    color="primary"
                    // className="basis-1/2 m-1 text-black italic bg-violet-200 hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100"
                    className="submit-reset"
                    type="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                  <Button
                    isLight={true}
                    color="primary"
                    // className="m-1"
                    className="submit-button"
                    onClick={handleSubmit(onSubmit)}
                    type="submit"
                  >
                    Submit
                  </Button>
                </form>
              </div>
            </CardFooter>
          </Card>
          <ToastComponent />
        </div>
      </div>
    </>
  );
}
